import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios';

Vue.config.productionTip = false

//axios.defaults.baseURL = "https://localhost:7010/";
//axios.defaults.baseURL = "https://testgesbol_back.rocol.org/";
axios.defaults.baseURL = "https://personal-api.policia.bo/";

// Establecer el token de autorización en los headers de Axios
//axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

/*
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');

    // Solo manda Authorization si la URL lo necesita
    const requiereAuth =
        //config.url.includes("/api/Users/Listar") ||
        config.url.includes("/api/Perfil") ||
        config.url.includes("/api/Reservas") ||
        config.url.includes("/api/Convenios/Crear") ||
        config.url.includes("/api/Convenios/Editar");

    if (token && requiereAuth) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
});
*/
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');

    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
});

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('oidu');
            localStorage.removeItem('rol');
            localStorage.removeItem('area');
            localStorage.removeItem('oidpersona');

            router.push('/');
        }

        return Promise.reject(error);
    }
);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
